import { useState, useRef } from "react";
import ReactSelect, { components } from "react-select";
import { useSelector } from "react-redux";
import darkcheckIcon from "../assets/images/darkcheckIcon.png";
import darkUploadIcon from "../assets/images/darkUploadIcon.png";
import checkboxIcon from "../assets/images/Checkbox.png";
import checkboxBaseIcon from "../assets/images/_Checkbox_base.png";
import darkCheckboxBaseIcon from "../assets/images/dark_base.png";
import styled from "styled-components/macro";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CheckImage = styled.img`
  height: 18px;
  width: 18px;
  object-fit: contain;
`;

const ListRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const DropdownIndicator = styled(components.DropdownIndicator)`
  padding: 4px;
`;
const InputBorder = styled.div`
  border: ${(props) =>
    props.error
     ? "1px solid #F97970"
      : props.themeColor
      ? "1px solid #333741"
      : props.menuIsOpen
      ? "1px solid #FBA976"
      : "1px solid #D7DAE0"};
  box-shadow: ${(props) =>
    props.menuIsOpen
      ? props.themeColor
        ? "#F05D24"
        : "0px 0px 0px 2px #FEE8D6"
      : ""};
  border-radius: 8px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  height: auto;
  padding: 1px 0px;
  /* border-radius: 8px; */
  width: 100%;
  display: flex;
  background-color: ${(props) => (props.themeColor ? "#161b26" : "#ffffff")};

  img {
    height: 18px;
    width: 18px;
  }

  input {
    font: 1.1rem;
  }
  input::placeholder {
    font-size: 0.8rem !important;
    color: ${(props) => (props.themeColor ? "#94969C" : "#8A94A6")};
  }
`;
export const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.7rem;
`;
export const InputLable = styled.label`
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.3rem;
  color: ${(props) => (props.themeColor ? "#CECFD2" : "#363a44")};
  margin-bottom: 0.5rem;
  text-transform: capitalize;

  @media (max-width: 351px) {
    font-size: 0.8rem;
  }
`;
export const InBox = styled.div`
  display: flex;
  color: ${(props) => (props.themeColor ? "#94969C" : "#8A94A6")};
  font-size: 0.8rem;
  align-items: center;
  width: 10%;

  img {
    height: 9px;
    width: 9px;
    object-fit: contain;
    margin-left: 4px;
  }
`;
const MultiSelect = ({
  options,
  value,
  onChange,
  isSelectAll,
  menuPlacement,
  error,
  type,
  icon,
  noBorderBottom,
  label,
  star,
  optional,
  erroros,
  feildLoading,
  ...props
}) => {
  const [selectInput, setSelectInput] = useState("");

  const theme = useSelector((state) => state?.isDark);
  const isAllSelected = useRef(false);

  const filterOptions = (options, input) =>
    options.filter((option) =>
      option.label.toLowerCase().includes(input.toLowerCase())
    );

  const Option = (props) => {
    // console.log(props, "props course");
    return (
      <components.Option {...props}>
        <ListRow>
          {props.isSelected || isAllSelected.current ? (
            theme ? (
              <CheckImage src={darkcheckIcon} alt="" />
            ) : (
              <CheckImage src={checkboxIcon} alt="" />
            )
          ) : theme ? (
            <CheckImage src={darkCheckboxBaseIcon} alt="" />
          ) : (
            <CheckImage src={checkboxBaseIcon} alt="" />
          )}
          <label>{props.label}</label>
        </ListRow>
      </components.Option>
    );
  };

  const Input = (props) => (
    <components.Input {...props} autoFocus={props.selectProps.menuIsOpen}>
      {props.children}
    </components.Input>
  );

  const customFilterOption = (option, inputValue) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase());
  };

  const onInputChange = (inputValue, actionMeta) => {
    if (actionMeta.action === "input-change") setSelectInput(inputValue);
    else if (actionMeta.action === "menu-close" && selectInput !== "")
      setSelectInput("");
  };

  const onKeyDown = (e) => {
    if ((e.key === " " || e.key === "Enter") && !selectInput)
      e.preventDefault();
  };

  const handleChange = (selected) => {
    onChange(selected);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      outline: state.isFocused ? "none" : null, // Hide outline on focus
      boxShadow: state.isFocused ? "none" : null, // Hide box shadow on focus
      // border: state.isFocused ? "1px solid #ccc" : "1px solid #ccc", // Border styles
      backgroundColor: theme ? "#0C111D" : "#ffffff",
      textTransform: "capitalize",
      border: "none", // Border styles
      borderRadius: "8px",
      fontWeight: "600", // Added font-weight here
      "&:hover": {
        outline: "none", // Hide outline on hover
        boxShadow: "none", // Hide box shadow on hover
      },
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      padding: 4,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "0.8rem", // Set your desired font size for the options
      textTransform: "capitalize",
      fontWeight: "500",
      // backgroundColor: "red",
      // backgroundColor: theme ? "#0C111D" : "#ffffff",
      // color: "#CECFD2",

      backgroundColor: state.isSelected
        ? theme
          ? "#1F242F"
          : "#F6F7F9" // Color for selected option
        : state.isFocused
        ? theme
          ? "#1F242F"
          : "#F6F7F9" // Color for option under mouse pointer
        : theme
        ? "#0C111D"
        : "#ffffff", // Default background color
      color: state.isSelected
        ? theme
          ? "#CECFD2"
          : "#363A44"
        : theme
        ? "#CECFD2"
        : "#363A44", // Text color for options
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontSize: "0.8rem", // Font size for the selected value
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "0.8rem", // Font size for the placeholder
      fontWeight: "400",
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: theme ? "#0C111D" : "#ffffff",
      // You can add other properties here to adjust the menu appearance
      // border: "none", // Example to remove any border
      border: theme ? "1px solid #333741" : "1px solid #D7DAE0", // Example to remove any border
      borderRadius: "8px", // Example to adjust border radius
      boxShadow: "0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A",
    }),
    MenuList: (provided, state) => ({
      ...provided,
      padding: "0px !important",
      backgroundColor: `${theme ? "#0C111D" : "#ffffff"} !important`,
    }),
    multiValue: (provided) => ({
      ...provided,
      borderRadius: "32px",
      backgroundColor: "rgb(246,89,28)", // Set your desired background color
      padding: "3px 9px", // Set your desired padding
      color: "white",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "0.8rem", // Set your desired font size for the labels
      color: "white",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      cursor: "pointer",
      borderRadius: "4px",
      backgroundColor: "transparent", // Set your desired background color
      ":hover": {
        backgroundColor: "transparent", // Set your desired background color on hover
      },
    }),
  };

  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const handleMenuOpen = () => {
    // Set the state to indicate that the menu is open
    setMenuIsOpen(true);
  };

  const handleMenuClose = () => {
    // Set the state to indicate that the menu is closed
    setMenuIsOpen(false);
  };

  const skeletonBaseColor = theme ? "#1F242F" : "#EDEEF1";
  const skeletonHighlightColor = theme ? "#1F242F" : "#EDEEF1";
  // const value = null;
  return (
    <InputBox>
      {feildLoading ? (
        <Skeleton
          width={80}
          height={18}
          style={{ marginBottom: "5px" }}
          baseColor={skeletonBaseColor}
          highlightColor={skeletonHighlightColor}
        />
      ) : (
        <InputLable themeColor={theme}>
          {label}
          {star ? <span style={{ color: "#F6591C" }}>*</span> : ""}
          {optional ? (
            <span style={{ color: "#667085" }}> (Optional)</span>
          ) : (
            ""
          )}
        </InputLable>
      )}

      {feildLoading ? (
        <Skeleton
          width={"100%"}
          height={40}
          baseColor={skeletonBaseColor}
          highlightColor={skeletonHighlightColor}
          style={{ marginBottom: "5px" }}
        />
      ) : (
        <InputBorder
          menuIsOpen={menuIsOpen}
          error={error || erroros}
          themeColor={theme}
        >
          <ReactSelect
            {...props}
            inputValue={selectInput}
            onInputChange={onInputChange}
            onKeyDown={onKeyDown}
            options={isSelectAll ? [...options] : options}
            onChange={handleChange}
            components={{ Option: Option, Input, DropdownIndicator }}
            filterOption={customFilterOption}
            menuPlacement={menuPlacement || "auto"}
            styles={customStyles}
            isMulti
            value={value}
            onMenuOpen={handleMenuOpen}
            onMenuClose={handleMenuClose}
            closeMenuOnSelect={false}
            tabSelectsValue={false}
            hideSelectedOptions={false}
            isSearchable={true}
            isClearable={false}
            backspaceRemovesValue={false}
            blurInputOnSelect={false}
          />
          {/* <Select
        styles={customStyles}
        isSearchable={false}
        isClearable={false}
        formatCreateLabel={(userInput) => `${userInput} (Add New Address)`}
        {...props}
      /> */}
          {/* {error ? <img src={errorImage} alt="" /> : ""} */}
        </InputBorder>
      )}

      {error || erroros ? (
        <p
          style={{
            paddingTop: 5,
            fontSize: 11,
            color: "#E0271A",
            fontWeight: "400",
            marginBottom: erroros ? 10 : 0,
          }}
        >
          {error || erroros}
        </p>
      ) : null}
    </InputBox>
  );
};

export default MultiSelect;
